exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dataset-buttons{position:absolute;right:0;top:-44px}", ""]);

// exports
